import React from "react";
import axios from "axios";
import * as IoIcons from "react-icons/io";

function EliminarAnexo(props) {
  const Eliminar = (e) => {
    e.preventDefault(e);
    axios({
      method: "put",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/EliminaAnexo?Id=" +
        props.id,
      data: {},
    })
      .then((Response) => {
        console.log(Response.data);
        alert(Response.data);
        window.location.reload("/");
      })
      .catch((error) => {
        console.log(error);
        alert("Error al eliminar la solicitud");
      });
  };
  return (
    <div>
      <button
        variant="contained"
        className="btn btn-danger"
        color="primary"
        onClick={Eliminar}
      >
        {" "}
        <IoIcons.IoIosCloseCircle />{" "}
      </button>
    </div>
  );
}

export default EliminarAnexo;
